import {AsyncValidatorFn, ValidatorFn} from '@angular/forms';
import {ErrorDetails} from './error-details';

export class Validation extends ErrorDetails {
  private _validation: ValidatorFn | AsyncValidatorFn;

  public constructor(validation: ValidatorFn | AsyncValidatorFn, errorKey: string, errorMessage: string) {
    super(errorKey, errorMessage);
    this._validation = validation;
  }

  public get validation(): ValidatorFn | AsyncValidatorFn {
    return this._validation;
  }

  public set validation(startRow: ValidatorFn | AsyncValidatorFn) {
    this._validation = startRow;
  }
}
